import { OrganizationExtraInfoFieldsModel } from '@core/models';
import { OrganizationDefaultColorModel } from '@core/services/organization/models';

export enum ModuleType {
    EmployeeExperience = 0,
    CustomerExperience = 1,
}

export const DEFAULT_MIN_ANONYMOUS_COUNT = 5;

export interface ProjectStatisticsViewModel {
    askemosCount: number;
    contactsCount: number;
    sessionsCount: number;
    projects: ProjectStatisticsProjectViewModel[];
}

export interface ProjectStatisticsProjectViewModel {
    id: string;
    name: string;
}

export interface ModuleHomeViewModel {
    askemosCount: number;
    sessionsCount: number;
    contactsCount: number;
    projects: ModuleHomeProjectViewModel[];
}

export interface ModuleHomeProjectViewModel {
    id: string;
    name: string;
    askemosCount: number;
    questionsCount: number;
    rolesCount: number;
    librariesCount: number;
    lastActivityDate?: string | null;
    lastSessionDate?: string | null;
}

export interface CurrentModuleDetailsViewModel {
    moduleId: string;
    organizationId: string;
    type: ModuleType;
    logoUrl?: string | null;
    logoId?: string | null;
    primaryLanguage?: string | null;
    activeLanguages: string[];
    name?: string | null;
    primaryContactFirstName?: string | null;
    primaryContactLastName?: string | null;
    primaryContactEmail?: string | null;
    primaryContactPhoneNumber?: string | null;
    extraInfoFields?: OrganizationExtraInfoFieldsModel;
    colors?: OrganizationDefaultColorModel | null;
    minAnonymousCount: number | null;
}

export interface UpdateCurrentModuleDetailsInputModel {
    name?: string | null;
    activeLanguages?: string[] | null;
    primaryLanguage?: string | null;
    logoId?: string | null;
    primaryContactFirstName?: string | null;
    primaryContactLastName?: string | null;
    primaryContactEmail?: string | null;
    primaryContactPhoneNumber?: string | null;
    extraInfoFields: OrganizationExtraInfoFieldsModel;
    colors?: OrganizationDefaultColorModel | null;
    minAnonymousCount: number | null;
}
